<template>
  <div
    id="displayMonitor"
    class="monitor"
    @dblclick="!isFullScreen ? fullScreenView() : exitFullScreen()"
    @fullscreenchange="isFullScreen = !isFullScreen"
    @mozfullscreenchange="isFullScreen = !isFullScreen"
    @webkitfullscreenchange="isFullScreen = !isFullScreen"
    @msfullscreenchange="isFullScreen = !isFullScreen"
    v-loading="isLoading"
    element-loading-text="Đang tải"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <img
      :src="link"
      :alt="'Monitor ' + $route.query.deviceId"
      style="width: 100%; border-radius: 10px"
      @load="isLoading = false"
      class="clickable"
    />
    <div
      class="btnControl clickable"
      @click="fullScreenView"
      v-show="!isFullScreen"
    >
      <i class="far fa-expand-wide"></i>
    </div>
    <div
      class="btnControl clickable"
      @click="exitFullScreen"
      v-show="isFullScreen"
    >
      <i class="fas fa-compress-wide"></i>
    </div>
    <p class="hightLight" v-show="!isLoading">
      <i class="far fa-dot-circle color__red"></i> Trực tiếp
    </p>
  </div>
</template>
<script>
import authen from "../../utils/authen";
export default {
  data() {
    return {
      link: "",
      isFullScreen: false,
      isLoading: true,
    };
  },
  created() {
    this.$get("api/stream").then((res) => {
      if (typeof res === "string") {
        this.link =
          res +
          `&scale=100&width=1280px&height=720px&buffer=5&mode=jpeg&maxfps=30&monitor=${
            this.$route.query.deviceId
          }&connkey=${Math.ceil(Math.random() * 30000)}`;
      }
    });
  },
  methods: {
    fullScreenView() {
      var elem = document.getElementById("displayMonitor");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    exitFullScreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
  },
};
</script>
<style lang="css" scoped>
.monitor {
  min-height: 75vh;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.btnControl {
  color: white;
  position: absolute;
  font-size: 30px;
  z-index: 10;
  bottom: 20px;
  right: 40px;
}
.hightLight {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  text-align: center;
  max-width: 130px;
  display: inline-block;
  margin: 10px;
  padding: 10px;
  background-color: #5b7377;
  display: block;
  border-radius: 10px;
  color: white;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/viewMulti/displayStream.vue